module.exports = {
  TestMasa: require("./build/contracts/TestMasa.json"),
  StkCorn: require("./build/contracts/StkCornv1.json"),
  BaseRewardsVault: require("./build/contracts/BaseRewardsVault.json")
};
